export default {"src":"/_next/static/media/facebook.a807fc23.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};